export function getAnalyticsDestination() {
  if (typeof window === 'undefined' || !window.Cookies) {
    return {};
  }
  const trackingPrefsCookie = JSON.parse(
    decodeURI(window.Cookies.get('segment-tracking-preferences'))
  );
  return trackingPrefsCookie?.destinations ?? {};
}

export function analyticsIdentify(userId, traits = {}) {
  const destinations = getAnalyticsDestination();
  return analytics.identify(userId, traits, {
    integrations: { ...destinations, 'Customer.io': false },
  });
}

export function analyticsTrack(eventName, properties = {}) {
  let options = {};
  if (currentUser?.identity_id) {
    options = { context: { identity_id: currentUser.identity_id } };
  }
  return analytics.track(eventName, properties, options);
}
